var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:['option', { 'selected': _vm.isSelected }],staticStyle:{"cursor":"pointer"},on:{"click":_vm.onRowSelected}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }